import { useEffect, useRef } from 'react';

function DigitInput({ value, setInputValue, lock, handleConfirm }: any) {
    useEffect(() => {
        setInput(value || '');
    }, [value]);

    const inputRef = useRef<HTMLInputElement[]>([]);

    function getDeviceID() {
        let value = '';
        for (let i = 0; i < 8; i++) {
            value += inputRef.current[i]?.value ?? '';
        }
        return value;
    }

    function setInput(value: any) {
        for (let i = 0; i < 8; i++) {
            if (inputRef.current[i]) {
                inputRef.current[i].value = value[i] ?? '';
            }
        }
    }

    function handleInput(e: any) {
        if (e.target.value !== '') {
            if (e.target.nextSibling) {
                e.target.nextSibling.focus();
            }
        }

        setInputValue(getDeviceID());
    }

    function handleKeyDown(e: any) {
        if (e.key === 'Backspace') {
            if (e.target.value === '') {
                if (e.target.previousSibling) {
                    e.target.previousSibling.value = '';
                    e.target.previousSibling.focus();

                    setInputValue(getDeviceID());
                }
            }
        } else if (e.key === 'Enter') {
            handleConfirm();
        }
    }

    function handleFocus(e: any) {
        if (e.target.value === '') {
            if (e.target.previousSibling && e.target.previousSibling.value === '') {
                e.target.previousSibling.focus();
            }
        } else {
            if (e.target.nextSibling) {
                e.target.nextSibling.focus();
            }
        }
        e.target.setSelectionRange(1, 1);
    }

    function handlePaste(e: any) {
        e.preventDefault();
        let paste = (e.clipboardData || (window as any).clipboardData).getData('text');
        let current = e.target;
        while (paste.length > 0) {
            current.value = paste[0];
            paste = paste.slice(1);
            if (!current.nextSibling) {
                break;
            }
            current = current.nextSibling;
            current.focus();
        }

        setInputValue(getDeviceID());
    }

    function onInput(e: any) {
        // convert to uppercase
        e.target.value = e.target.value.toUpperCase();
    }

    const inputClassName =
        'mx-1.5 h-12 w-6 border-0 border-b-2 border-[#D5DAE3] bg-white text-center text-[2rem] font-semibold text-[#1F252E] caret-transparent placeholder:text-[2rem] placeholder:text-[#D5DAE3] focus:border-[#2763EA] focus:outline-none disabled:text-[#C7CCD7]';

    return (
        <div className='flex flex-nowrap items-center justify-center gap-1.5 overflow-x-auto'>
            {['A', 'B', 'C', 'D', '1', '2', '3', '4'].map((placeholder: any, index: any) => (
                <input
                    key={placeholder}
                    type='text'
                    disabled={lock}
                    placeholder={placeholder}
                    className={inputClassName}
                    maxLength={1}
                    ref={(el: any) => {
                        inputRef.current[index] = el;
                    }}
                    onKeyDown={handleKeyDown}
                    onChange={handleInput}
                    onFocus={handleFocus}
                    onPaste={handlePaste}
                    onInput={onInput}
                />
            ))}
        </div>
    );
}

export default DigitInput;

// return (
//     <div>
//         <input type='text' placeholder='1' className='device-id' maxLength={1} tabbable='true' ref={el => inputRef.current[0] = el}/>
//         <input type='text' placeholder='2' className='device-id' maxLength={1} tabbable='true' ref={el => inputRef.current[1] = el}/>
//         <input type='text' placeholder='3' className='device-id' maxLength={1} tabbable='true' ref={el => inputRef.current[2] = el}/>
//         <input type='text' placeholder='4' className='device-id' maxLength={1} tabbable='true' ref={el => inputRef.current[3] = el}/>
//         <input type='text' placeholder='5' className='device-id' maxLength={1} tabbable='true' ref={el => inputRef.current[4] = el}/>
//         <input type='text' placeholder='6' className='device-id' maxLength={1} tabbable='true' ref={el => inputRef.current[5] = el}/>
//         <input type='text' placeholder='7' className='device-id' maxLength={1} tabbable='true' ref={el => inputRef.current[6] = el}/>
//         <input type='text' placeholder='8' className='device-id' maxLength={1} tabbable='true' ref={el => inputRef.current[7] = el}/>
//     </div>
// )
